import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	error: {
		id: 'issue-field-statistics.numeric-stats-container.error',
		defaultMessage: " We couldn't load your data. Try again or <link>contact support</link>.",
		description:
			'Error message we display when network calls fails in the list view statistics sidebar',
	},
	spinnerLabel: {
		id: 'issue-field-statistics.common.async-handler.spinner-label',
		defaultMessage: 'Loading',
		description: 'The label for the loading spinner, for accessibility purposes',
	},
	noData: {
		id: 'issue-field-statistics.common.async-handler.no-data',
		defaultMessage: 'No data available',
		description: 'Message displayed when there is no data to show',
	},
});
